module.exports = __webpack_public_path__ + "static/media/pm.1c9c86ad.svg";